import React from "react";
import Meaning from "./Meaning";
import Phonetic from "./Phonetic";
import "./result.css";



const Result = (props) => {
   
  if (props.result) {
    
  return (
    <>
      <div className="Result">
    <section>
        <h2>{props.result.word}</h2>
        {props.result.phonetics.map(function (phonetic, index) {
          return (
            <div key={index}>
              <Phonetic phonetic={phonetic} />
            </div>
          );
        })}
        </section>
        <p>
          {props.result.meanings.map(function (meaning, index) {
            return (
              <>
                <section key={index}>
                  <Meaning meaning={meaning} />
                </section>
              </>
            );
          })}
        </p>
       
      </div>
    </>
  );
  } else {
    return null;
  }
    
};
export default Result;